import styled from 'styled-components';

export const Container = styled.nav`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    max-height: 856px;
    width: 116px;
    background-color: #fff;
    border-radius: 3px;
    transition: 0.5s;
    z-index: 9;
    overflow-y: scroll;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 1330px) {
        display: none;
    }

    .telas {
        margin-top: 131px;

        .tela-not-allowed {
            transition: 0.2s;
            cursor: not-allowed;
            opacity: 0.3;

            width: 108px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 16px;
            padding-bottom: 16px;
            border-bottom-right-radius: 10px;
            border-top-right-radius: 10px;

            :hover {
                background-color: #faf8f8
            }

            .icones {
                padding-left: 8px; 
                width: 16px;
                height: 16px;
                object-fit: contain;
            }

            h3 {
                padding-left: 8px; 
                margin-bottom: 0px;
                margin-top: 12px;
                font-family: Montserrat;
                color: #a49b9b;
                font-weight: 400;
                font-size: 10px
            }
        }

        .tela {
            transition: 0.2s;
            cursor: pointer;
            opacity: 1;

            width: 108px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 16px;
            padding-bottom: 16px;
            border-bottom-right-radius: 10px;
            border-top-right-radius: 10px;

            :hover {
                background-color: #faf8f8
            }

            .icones {
                color: #000;
                padding-left: 8px; 
                width: 16px;
                height: 16px;
                object-fit: contain;
            }

            h3 {
                padding-left: 8px; 
                margin-bottom: 0px;
                margin-top: 12px;
                font-family: Montserrat;
                color: #a49b9b;
                font-weight: 400;
                font-size: 10px
            }
        }

        .telaatual {
            transition: 0.2s;
            cursor: pointer;
            width: 108px;
            background-color: #d7232c;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 16px;
            padding-bottom: 16px;
            border-bottom-right-radius: 10px;
            border-top-right-radius: 10px;

            .icones {
                padding-left: 8px; 
                width: 16px;
                height: 16px;
                object-fit: contain;
            }

            h3 {
                padding-left: 8px; 
                margin-bottom: 0px;
                margin-top: 12px;
                font-family: Montserrat;
                color: #fff;
                font-weight: 400;
                font-size: 10px
            }
        }

        hr {
            width: 100%;
            border-top: 1px solid #f3f3f3;
            margin: auto;
            margin-top: 24px;
            margin-bottom: 24px
        }

        .sair {
            margin-bottom: 24px;
            transition: 0.2s;
            cursor: pointer;
            width: 108px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 16px;
            padding-bottom: 16px;
            border-bottom-right-radius: 10px;
            border-top-right-radius: 10px;

            :hover {
                background-color: #faf8f8
            }

            .icones {
                padding-left: 8px; 
                width: 16px;
                height: 16px;
                object-fit: contain;
            }

            h3 {
                padding-left: 8px; 
                margin-bottom: 0px;
                margin-top: 12px;
                font-family: Montserrat;
                color: #a49b9b;
                font-weight: 400;
                font-size: 10px
            }
        }
    }
`